export default () => {
  $('pre code.html').each((index, code) => {
    const $code = $(code);
    const seed = Math.floor(Math.random() * 1000000000000);
    $(`<input id="toggle-${seed}" type="checkbox" />`).insertBefore($code);
    $(`<label for="toggle-${seed}">Show example code...</label>`).insertBefore($code);
  });
};
